import React from "react";
import { dateTimeFormat } from "@/lib/dateTime";
import moment from 'moment';
import { Typography } from 'antd';

interface state {
  dateTime: any;
}

class Countdown extends React.Component<{}, state> {
  state = {
    dateTime: '',
  };
  autoCount: any;

  componentDidMount() {
    this.autoCount = setInterval(this.refreshTime, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.autoCount);
  }

  refreshTime = () => {
    const now = moment().format(dateTimeFormat);
    this.setState({ dateTime: now });
  }

  render() {
    const { dateTime } = this.state;

    return (
      <Typography.Title>{dateTime}</Typography.Title>
    );
  }
}

export default Countdown;